import { Radio } from "antd";

const CustomInputRadioField = ({
  register = () => {},
  errors = {},
  checked,
  watch,
  setValue = () => {},
  viewOnly = false,
  labelName = "",
  options = "",
  name = "",
}) => {
  const activeValue = viewOnly ? "" : watch(name);

  return (
    <>
      <label
        className="form-label title mb-2"
        style={{ color: "#4B4853" }}
        htmlFor=""
      >
        {viewOnly ? "Status" : labelName}
        <span className="star"> * </span>
      </label>
      <div className="d-flex justify-content-evenly gap-3">
        {options.map((status, index) => (
          <div
            key={index}
            className={`radioBtnWrapper form-check form-check-inline fs16fwb w-100 d-flex justify-content-center ${activeValue === status ? "inputRadioBtn" : ""}`}
            onClick={() => {
              if (!viewOnly) {
                setValue(name, status);
              }
            }}
            style={{ cursor: viewOnly ? "default" : "pointer" }}
          >
            {viewOnly ? (
              <Radio
                name={name}
                id={`active-${status}`}
                value={status}
                checked={checked ? "checked" : ""}
                disabled
              >
                <span>{status}</span>
              </Radio>
            ) : (
              <Radio
                name={name}
                id={`active-${status}`}
                {...register(name, { required: true })}
                value={status}
                checked={activeValue === status}
                onChange={() => {
                  setValue(name, status);
                }}
              >
                <span>{status}</span>
              </Radio>
            )}
          </div>
        ))}
      </div>
      {errors?.[name] &&
        (activeValue === null || activeValue === undefined) && (
          <div className={`invalid-feedback d-block`}>
            Please select an Option
          </div>
        )}
    </>
  );
};

export default CustomInputRadioField;
